import { Box, HStack, VStack, Text } from "@chakra-ui/react";
import { BaseBlockProps } from "./types";

interface ListContent {
  items?: ListItem[];
  ordered?: boolean;
}

type ListItem = string | { text: string; subtext?: string };

export const ListBlock = ({ block }: BaseBlockProps) => {
  // Handle both flat and nested content structure
  const content = block.content as ListContent | undefined;
  const items = content?.items || (block.items as ListItem[]) || [];
  const isOrdered = content?.ordered ?? block.ordered === true;

  if (items.length === 0) {
    return null;
  }

  return (
    <VStack align="stretch" spacing="xs">
      {items.map((item, i) => {
        const isObject = typeof item === "object" && item !== null;
        const text = isObject ? item.text : item;
        const subtext = isObject ? item.subtext : undefined;

        return (
          <HStack key={i} align="start" spacing="sm">
            {isOrdered ? (
              <Text
                fontSize="xs"
                color="text.body.secondary"
                minW="16px"
                flexShrink={0}
              >
                {i + 1}.
              </Text>
            ) : (
              <Box
                w={1}
                h={1}
                bg="text.body.secondary"
                borderRadius="full"
                mt={1.5}
                flexShrink={0}
              />
            )}
            <VStack align="start" spacing={0}>
              <Text fontSize="xs" color="text.body.primary">
                {text}
              </Text>
              {subtext && (
                <Text fontSize="xs" color="text.body.secondary">
                  {subtext}
                </Text>
              )}
            </VStack>
          </HStack>
        );
      })}
    </VStack>
  );
};
